export default __webpack_public_path__ + "static/4-f1e2f71f69e8700122ebb05e0299b532.webp";